import { Colors } from "@snapchat/snap-design-system";

import { type OrganicStat } from "../../gql-generated/types";
import { getPercentage } from "../math";
import { type OsStatsItem } from "../models";
import { osDimensionLabelMap } from "../models/dimension-funnel";

const colorsBreakdown = [
    Colors.Black.V100,
    Colors.Black.V50,
    Colors.Gray.V300,
    Colors.Gray.V250,
    Colors.Gray.V200,
    Colors.Gray.V150,
    Colors.Gray.V100,
];

export const mapOsBreakdown = (stats: readonly OrganicStat[]): OsStatsItem[] => {
    const sum = stats.reduce((acc, { value }) => acc + Number.parseInt(value), 0);

    return stats
        .map((stat) => ({ ...stat, value: Number.parseInt(stat.value) }))
        .sort(({ value: value1 }, { value: value2 }) => value2 - value1)
        .map(({ value, dimensionBreakdown }, index) => {
            return {
                value,
                label: osDimensionLabelMap[dimensionBreakdown] ?? dimensionBreakdown,
                dimensionBreakdown,
                color: colorsBreakdown[index],
                valuePercent: getPercentage(value, sum),
            };
        });
};
